import { DateTime } from 'luxon'

export function formatDate(date: string) {
  return DateTime.fromISO(new Date(date).toISOString()).toLocaleString(DateTime.DATE_FULL)
}

export function formatDateYYYYMMDD(date: Date) {
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, '0') // Months are zero-based
  const day = date.getDate().toString().padStart(2, '0')

  return `${year}-${month}-${day}`
}

export function formatDateDDMMYYYY(date: Date, slashSeparator?: boolean): string {
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0') // Months are zero-based
  const year = date.getFullYear()

  if (slashSeparator) return `${day}/${month}/${year}`
  else return `${day}-${month}-${year}`
}

export function calculateDateDifferenceInDays(date1: Date, date2: Date): number {
  const diffTime = Math.abs(date2.getTime() - date1.getTime())
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return diffDays
}

export function isDateAfter(date1: Date, date2: Date): boolean {
  return date1.getTime() > date2.getTime()
}
